import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import { setUser, initialState as initialUserState } from '../store/auth/userSlice'
import { setLayout } from '../store/theme/themeSlice'
import { LAYOUT_TYPE_MODERN } from '../constants/theme.constant'

const unauthorizedCode = [401]

const BaseService = axios.create({
    timeout: 60000,
    mode: 'no-cors',
    baseURL: appConfig.apiPrefix,
    headers: {
        "Access-Control-Allow-Headers": "origin, content-type, accept",
         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,POST,PATCH,PUT,DELETE,OPTIONS'
    }
})

BaseService.interceptors.request.use(config => {

    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)

    const accessToken = persistData.auth.session.token

    if (accessToken) {
        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
    }
    
    return config
}, error => {
    return Promise.reject(error)
})

BaseService.interceptors.response.use(
    response => response,
    error => {

        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            localStorage.removeItem("userDetails")
            localStorage.removeItem("access_token")
            localStorage.removeItem("login_time")
            localStorage.removeItem("userType")
            store.dispatch(onSignOutSuccess())
            store.dispatch(setUser(initialUserState))
            store.dispatch(setLayout(LAYOUT_TYPE_MODERN))
        }

        return Promise.reject(error)
    }
)

export default BaseService
